import { GetterTree } from "vuex";
import { IFDGState } from "@/core/interfaces/state/fdgState.interface";
import { IFDG } from "@/core/interfaces/state/fdg.interface";
import { IFDGDetail } from "@/core/interfaces/state/fdgDetail.interface";
import {
  IFDGBookingDetail,
  IFDGBookingPassenger,
} from "@/core/interfaces/state/fdgBookingDetail.interface";
import { StoreState } from "@/store/type";
import { FlightLeg } from "@/core/types/flight";

const getters: GetterTree<IFDGState, StoreState> = {
  isFetchingFDGList: (state): boolean => state.isFetchingFDGList,
  fdgList: (state): Array<IFDG> => state.fdgList,
  fdgDetail: (state): IFDGDetail | null => state.fdgDetail,
  isFetchingFDGDetail: (state): boolean => state.isFetchingFDGDetail,
  fdgBookingDetail: (state): IFDGBookingDetail | null => state.fdgBookingDetail,
  isFetchingFDGBookingDetail: (state): boolean =>
    state.isFetchingFDGBookingDetail,
  isInitiatingFDGBooking: (state): boolean => state.isInitiatingFDGBooking,
  isConfirmFDGBooking: (state): boolean => state.isConfirmFDGBooking,
  isConfirmFDGBookingWithoutTravelerDetails: (state): boolean =>
    state.isConfirmFDGBookingWithoutTravelerDetails,
  totalNumberofPassengers: (state): number | undefined =>
    state.fdgBookingDetail?.numberOfGuests,
  flightLegItems: (state): FlightLeg[] | undefined =>
    state.fdgBookingDetail?.flightLegItems,
  isOTPLoading: (state): boolean => state.isOTPVerificationInProgress,
  isGroupBookingPassengersFetching: (state): boolean =>
    state.isGroupBookingPassengersFetching,
  groupBookingPassengers: (state): IFDGBookingPassenger[] => state.passengers,
  groupFlightsOTPReference: (state): string => state.bookingFormOTPReference,
  isGroupFlightsPaynowLoading: (state): boolean =>
    state.isGroupFlightsPaynowLoading,
};

export default getters;
